import { render, staticRenderFns } from "./blessingox.vue?vue&type=template&id=12480078&scoped=true"
import script from "./blessingox.vue?vue&type=script&lang=js"
export * from "./blessingox.vue?vue&type=script&lang=js"
import style0 from "./blessingox.vue?vue&type=style&index=0&id=12480078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12480078",
  null
  
)

export default component.exports